"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textHide = textHide;
exports["default"] = void 0;
/**
 * @public
 * @description Hides text.
 * @returns {string}
 */

function textHide() {
  return "\n    font: 0/0 a;\n    color: transparent;\n    text-shadow: none;\n    background-color: transparent;\n    border: 0;\n  ";
}

var _default = {
  textHide: textHide
};
exports["default"] = _default;